import { barChartLabelFormatter } from "@/common/utils/barChartLabelFormatter"

export const CustomChartLabel = ({ x, y, width, height, value, format_parser }: any) => {
  const formatted = barChartLabelFormatter(value, format_parser)

  if (width < 30) return null
  const fontSize = 10
  const textY = height > 20 ? y + height / 2 + fontSize / 2 : y - 5
  const textAnchor = 'middle'
  const textX = x + width / 2

  return (
    <text x={textX} y={textY} fill="#fff" fontSize={fontSize} textAnchor={textAnchor}>
      {formatted}
    </text>
  )
}

export default CustomChartLabel
